import { AppsFilterAtom } from "pages/browse-apps/browse-apps.service";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import {
	get_All_Addons_wishList,
	get_All_app_wishList,
} from "services/wishListServices";

export function useApplicationWishList(customerId:any) {
	const { t } = useTranslation();
	const filters = useRecoilValue(AppsFilterAtom);
	const { isLoading, isError, isFetching, isSuccess, ...result } = useQuery(
		["apps-wishList", t, filters],
		async () => {
			const params = {
				searchTerm: filters.search,
				customerId:customerId
			};
			const { response } = await get_All_app_wishList(params);
			if (response) return response;
		}
	);

	return {
		...result,
		appsWishList: result.data ?? [],
		isLoading,
		isError,
		isFetching,
		isSuccess,
	};
}

export function useAddonsWishList(customerId:any) {
	const { t } = useTranslation();
	const filters = useRecoilValue(AppsFilterAtom);

	const { isLoading, isError, isFetching, isSuccess, ...result } = useQuery(
		["addons-wishList", t, filters],
		async () => {
			const params = {
				searchTerm: filters.search,
				customerId:customerId
			};
			const { response } = await get_All_Addons_wishList(params);
			if (response) return response;
		}
	);

	return {
		...result,
		addonsWishList: result.data ?? [],
		isLoading,
		isError,
		isFetching,
		isSuccess,
	};
}
